import React from 'react';
import { candidateHiringOptions } from 'components/candidates/profile/scorecards/CandidateScorecardStore';

const getHireabilityChoiceOptions = () =>
	candidateHiringOptions.map(option => ({
		...option,
		label: (
			<div className="is-flex gap-1 is-align-items-center">
				<img
					className="hireability-option-icon"
					src={`/ats/icons/face-${
						option.value === 'yes'
							? 'happy'
							: option.value === 'no'
								? 'sad'
								: 'neutral'
					}-icon.svg`}
					alt={option.text}
				/>
				{option.text}
			</div>
		)
	}));

export const getHireabilityDropdownOptions = () => [
	{
		text: 'Not set',
		value: null,
		label: (
			<div className="is-flex gap-1 is-align-items-center">
				<img
					className="hireability-option-icon"
					src="/ats/icons/hireability-empty-icon.svg"
					alt="Not set"
				/>
				Not set
			</div>
		)
	},
	...getHireabilityChoiceOptions()
];

export const getHireabilityFilterOptions = () => [
	{ label: 'All', value: null },
	...getHireabilityChoiceOptions()
];
